
export class ItemNode {
    Id: string;
    Description?: string;
    Order: number;
    maxSelectableChildren?: number;
    children?: ItemNode[];
    checkable?: boolean = false;
    selected?: boolean = false;

    constructor(itemNode: ItemNode, excludeInternals: boolean = false, excludeChildren: boolean = false) {

        if (!itemNode)
            return;

        this.Id = itemNode.Id ?? itemNode.guid ?? itemNode.id;
        this.Description = itemNode.Description ?? itemNode.description;
        this.Order = itemNode.Order;

        if (itemNode.selected) {
            this.selected = true;
        }

        if (!excludeChildren) {
            let children = itemNode.children ?? itemNode.Children;
            this.children = children?.map(c => new ItemNode(c));
        }

        if (!excludeInternals) {
            this.maxSelectableChildren = itemNode.maxSelectableChildren;
            this.checkable = itemNode.checkable ?? itemNode.Checkable;
        }
    }

    get id(): string {
        return this.Id;
    }

    get guid(): string {
        return this.Id;
    }

    get description(): string {
        return this.Description;
    }

    get Children(): ItemNode[] | undefined {
        return this.children;
    }

    get Checkable(): boolean {
        return this.checkable;
    }
}

export class ItemFlatNode extends ItemNode {
    selectable?: boolean;
    level: number;
    expandable: boolean;
    visible = true;
}

export class ItemNodeWithParent {
    parentId: string;
    itemNode: ItemNode;
    constructor(_itemNode: ItemNode) {
        this.itemNode = _itemNode;
    }
}
